import React from "react";
import { Field, reduxForm } from "redux-form";
import { Button, Col, Row } from "antd";
import S from "string";
import { renderField } from "utils/forms";

const fields = ["password", "password_confirmation"];
const validate = values => {
  const errors = {};

  fields.forEach(function(field) {
    if (!values[field]) {
      errors[field] = `${S(field).humanize().s} required`;
    }
  });

  if (
    values.password &&
    values.password_confirmation &&
    values.password !== values.password_confirmation
  ) {
    errors.password_confirmation = "Passwords do not match";
  }

  return errors;
};

let ResetPasswordForm = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row type="flex" justify="center" align="middle">
        <Col md={8} xs={20}>
          <Field
            label="Password"
            name="password"
            component={renderField}
            type="password"
          />
        </Col>
      </Row>
      <Row type="flex" justify="center" align="middle">
        <Col md={8} xs={20}>
          <Field
            label="Password confirmation"
            name="password_confirmation"
            component={renderField}
            type="password"
          />
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col md={6} xs={20}>
          <Button
            style={{
              width: "100%"
            }}
            type="primary"
            htmlType="submit"
          >
            Reset Password
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default reduxForm({
  form: "resetPassword",
  validate
})(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/auth/forms/reset-password.js